import { useEffect } from "react";
import useTitle from "../hooks/useTitle";

const Layout = ({ title, children }) => {
  const { setTitle } = useTitle();

  useEffect(() => {
    setTitle(title);

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <main>{children}</main>;
};

export default Layout;
